module.exports = __webpack_public_path__ + "img/left-arrow.33118db5.svg";